import { jsx as _jsx } from "react/jsx-runtime";
import merge from 'lodash.merge';
import { createContext, useMemo } from 'react';
import { LOCALES } from '../../locales';
export const DEFAULT_LANG = 'en_GB';
export const LocaleContext = createContext({
    lang: DEFAULT_LANG,
    locales: LOCALES,
    localesByLang: LOCALES.en_GB,
});
export function LocaleProvider({ lang: langProp, locales: localesProp, children }) {
    const locales = useMemo(() => {
        if (localesProp) {
            return merge({}, LOCALES, localesProp);
        }
        return LOCALES;
    }, [localesProp]);
    const lang = useMemo(() => langProp.replace('-', '_'), [langProp]);
    const localesByLang = useMemo(() => {
        let localesObj = locales[lang];
        if (!localesObj) {
            console.warn(`Snack-uikit: localization for lang ${lang} was not found. Make sure you are using correct lang or passed proper locales to LocaleProvider. For now default language (${DEFAULT_LANG}) will be used`);
            localesObj = locales[DEFAULT_LANG];
        }
        return localesObj;
    }, [lang, locales]);
    return _jsx(LocaleContext.Provider, { value: { lang, locales, localesByLang }, children: children });
}
